import { SiteMasterListItemModel } from '@customer-portal/data-access/global';
import { GridEventActionType } from '@customer-portal/shared';

import { SettingsSitesItemModel } from '../../models';

export class SettingsSitesMapper {
  static mapToSitesList(
    siteMasterListItems: SiteMasterListItemModel[],
    isAdmin: boolean,
    isDnvUser: boolean,
  ): SettingsSitesItemModel[] {
    if (!isAdmin) {
      return siteMasterListItems.map((item) => ({ ...item }));
    }

    return siteMasterListItems.map((item) => ({
      ...item,
      eventActions: {
        id: item.id,
        actions: [
          {
            label: GridEventActionType.ManageNickname,
            i18nKey: `gridEvent.${GridEventActionType.ManageNickname}`,
            icon: 'pi pi-user-plus',
            disabled: isDnvUser,
          },
          {
            label: GridEventActionType.RequestChanges,
            i18nKey: `gridEvent.${GridEventActionType.RequestChanges}`,
            icon: 'pi pi-pencil',
            disabled: isDnvUser,
          },
        ],
      },
    }));
  }
}
